export default "__VITE_ASSET__DjgoObUZ__"